// extracted by mini-css-extract-plugin
export default {"bookTable":"Table_bookTable__f4egp"};